import React from "react";
import { ReactComponent as VehicleBlue } from "assets/images/icons/_Vehicle_blue.svg";

import StyleWrapper from "./style";
import { useTranslation } from "react-i18next";
import { ConvertToEnglishLetters } from "helpers/plate-number-converter.util";

const VehicleCard = (props) => {
  const { i18n } = useTranslation();
  return (
    <StyleWrapper className={props.className || ""} businessColor={props.businessColor}>
      <div className="card_wrapper">
        <VehicleBlue />
        <div className="info_wrapper justify-content-center">
          {
            props.plateNumber? 
            <p style={{direction: i18n.dir() === 'rtl' ? 'ltr' : ''}} className="m-0 plate">{props.plateNumber}{" "}
            {
                ConvertToEnglishLetters(props.vehicle.plateTextLeft) 
              +" "+ 
              ConvertToEnglishLetters(props.vehicle.plateTextMiddle)
              +" "+
            
              ConvertToEnglishLetters(props.vehicle.plateTextRight)
            }
          </p>:
          <p style={{direction: i18n.dir() === 'rtl' ? 'ltr' : ''}} className="m-0 plate">
            <span>{props.vehicle.makeName}</span>{ props.vehicle.modelName && ` - ${props.vehicle.modelName }`}
          </p>
          }
        </div>
      </div>
    </StyleWrapper>
  );
};

export default VehicleCard;
